import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./Invoice.css";
import Image from'../Assets/logo.png'
// import { useParams } from "react-router-dom";

const PrintEstimateInvoice = () => {
//   const { id: order_id } = useParams(); 
  const [orderData, setOrderData] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [imageLoaded, setImageLoaded] = useState(false);

//   useEffect(() => {

//     const fetchOrderDetails = async () => {
//       try {
//         const response = await axios.post(
//           `${API_BASE_URL}print_customer_list.php`,
        
//         );

//         if (response.data.head.code === 200) {
//           setOrderData(response.data.body);
//         } else {
//           console.error("Failed to fetch order details");
//         }
//       } catch (error) {
//         console.error("Error fetching order details:", error);
//       }
//     };

//     fetchOrderDetails();
//   }, []);

useEffect(() => {
  const data = localStorage.getItem('agentestimate');
  if (data) {
    setOrderData(JSON.parse(data));
    // const firstAgent = orderData[0]?.agent;
    // console.log(firstAgent);
  }
  
}, []);

   useEffect(() => {
    if (orderData ) {
      setTimeout(() => {
        window.print();
      }, 300); // slight delay to ensure everything is rendered
    }
  }, [orderData]);

  if (!orderData) {
    return <p>Please Wait Loading...</p>;
  }

  return (
    <div className="invoice-wrapper">
      <div className="invoice-container">
        <table className="invoice-table">
          <tbody>
            {/* Header with Logo */}
            <tr>
             <div style={{ textAlign: "center",paddingTop:"30px" }}>
  <img src={Image} alt="Print" style={{ border: 0 ,width:"15%"}} />
</div>

      {/* <h2 style={{ textAlign: "center", marginBottom: "10px",color:"black" }}>Estimate Invoice</h2> */}
      <div style={{ padding:"10px", display: "flex", justifyContent: "space-between", borderBottom: "1px solid black", paddingBottom: "10px" }}>
      <div>
    {orderData && (
    <>
      <strong>{orderData[0]?.shop_name}</strong>,
      <br />
      <strong>{orderData[0]?.gst_no}</strong>,
      <br />
      {orderData[0]?.address}
      <br />
      {orderData[0]?.city}
      <br />
      {orderData[0]?.state} - {orderData[0]?.pincode}
      <br />
      {orderData[0]?.phone}
      <br />
      
    </>
  )}
</div>


  {/* {orderData ? (
          <div>
          <strong>Invoice No:</strong> {orderData.estimate_id}
          <br />
          <strong>Dated:</strong> {orderData.estimate_date}
          </div>
          ) : (
            <p> </p>
          )} */}

      </div>
              
            </tr>
          <tr>
            {/* <td  align="left"><b>Agent Name</b></td> */}
             <td ><b><h4>Agent Name : {orderData[0]?.agent}</h4></b></td>
             {/* <td></td> */}
            </tr>

            {/* Product Table */}
            <tr>
              <td className="products-section">
                <table className="product-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Customer Name</th>
                      <th>Mobile</th>
                      <th>Amount</th>

                    </tr>
                  </thead>
                  <tbody>
                    {/* {orderData.map((item, index) => ( */}
                    {Array.isArray(orderData) && orderData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.estimatedate}</td>
                       
                        <td>{item.name || "N/A"}</td>
                        <td style={{textAlign:"center"}} >{item.billing_phonenumber || "N/A"}</td>
                        <td style={{textAlign:"right"}}>
                         <i className="fas fa-rupee-sign"></i> {parseFloat(item.amount.replace(/,/g, "") || 0).toFixed(2)}
                        </td>
                        
                      </tr>
                    ))}
                    {/* Calculate and display Sub-Total */}
{Array.isArray(orderData) && orderData.length > 0 && (
  <tr>
    <td colSpan="4" align="right"><b>Total</b></td>
    <td align="right">
      ₹{orderData
        .reduce((total, item) => {
          const cleanAmount = parseFloat(item.amount.replace(/,/g, "")) || 0;
          return total + cleanAmount;
        }, 0)
        .toFixed(2)}
    </td>
  </tr>
)}
                    {/* <tr>
                      <td colSpan="3" align="right"><b>SGST (9%)</b></td>
                      <td align="right">₹{orderData.sgst_amt}</td>
                    </tr> */}
                    {/* <tr>
                      <td colSpan="3" align="right"><b>Discount ({orderData.discount_percentage}%)</b></td>
                      <td align="right">₹{orderData.discount_amt}</td>
                    </tr> */}
                     {/* <tr>
                      <td colSpan="3" align="right"><b>CGST</b></td>
                      <td align="right">₹{orderData.cgst_amt}</td>
                    </tr>
                     <tr>
                      <td colSpan="3" align="right"><b>SGST</b></td>
                      <td align="right">₹{orderData.sgst_amt}</td>
                    </tr> */}
                    {/* <tr>
                      <td colSpan="3" align="right"><b>Grand Total</b></td>
                      <td align="right">₹{orderData.total}</td>
                    </tr> */}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrintEstimateInvoice;
